import {UpdateQueryOptions} from "../../../../common/state/query.actions";

// export class UpdateInvoiceChargesQuery {
//   static readonly type = '[INVOICE_CHARGES] Update Query';
//
//   constructor(public options?: UpdateQueryOptions) {
//   }
// }

export class UpdateInventoryDocumentActiveSiderSection {
  static readonly type = '[INVENTORY_DOCUMENT] Update active sider section';
  constructor(public name: string) {}
}
